const statusToColorDict = {
    "Completed": "green",
    "Processing": "blue",
    "Failed": "red",
    "FailedNoData": "yellow",
    "Not Started": "blue",
} as const;

export const getNodeStatusColor = (transcriptStatus: string) => {
    const color: string | undefined = statusToColorDict[transcriptStatus as keyof typeof statusToColorDict];
    return color || "blue";
}